import React from 'react';
import './breadcrumbItem.scss';
import { dlTrackPLPBreadcrumb } from '../../analytics/productListAnalytics';

const BreadcrumbItem = ({ title, url, index }) => {
  return (
    <li
      className="breadcrumbs__item"
      key={`breadcrumb-item_${index + 1}`}
      itemScope
      itemProp="itemListElement"
      itemType="http://schema.org/ListItem"
    >
      <a className="js-tracking-breadcrumbs" itemProp="item" href={url} onClick={() => dlTrackPLPBreadcrumb(url)}>
        <span itemProp="name">{title}</span>
      </a>
      <meta itemProp="position" content={index + 2} />
    </li>
  );
};

export default BreadcrumbItem;
